export default "__VITE_ASSET__88e8cb1b__"